import React, { FC, useEffect } from 'react';
import './Bonus.scss';
import Main from './pages/Main';
import { Empty } from '../../generated/google/protobuf/empty';
import { useDispatch } from 'react-redux';
import { DistributionClient } from '../../generated/mlmbox/client/distribution/distribution.client';
import { transport } from '../../utils/constants';
import { setDistribution } from '../../store/distribution/distribution.slice';
import { getToken } from '../../utils/helper';

const Bonus: FC = () => {
    const distributionClient = new DistributionClient(transport);
    const dispatch = useDispatch();

    useEffect(() => {
        distributionClient.info(Empty, { meta: { authorization: getToken() } }).then((data) => {
            dispatch(setDistribution(data.response));
        });
    }, []);

    return (
        <div className={`bonus`}>
            <Main />
        </div>
    );
};

export default Bonus;
